import React, { createContext, useState, useEffect } from 'react';
import firebase from '../Firebase.js';

export const TrainerContext = createContext();

export default (props) => {
  const [state, setState] = useState({
    examReasons: {},
    defaultComments: {},
    trickNames: {},
    tricks:{},
    pendingExam: null,
    numberOfExams: null,
    clients: null,
    admins: null,
  });

  const setPendingExam = pe => setState(s => {
    return { ...s,  pendingExam: pe };
  });

  useEffect(() => {
    const getTrickNamesAndExamReasons = async () => {
      const trickNames = (
        await firebase.database().ref("localizedTrickNames").once("value")
      ).val();
      const tricks = (
        await firebase
          .firestore()
          .collectionGroup("trickTranslations")
          .get()
      ).docs.map((d) => d.data());
      const examComments = (
        await firebase
          .firestore()
          .collectionGroup("trickExamCommentTranslations")
          .get()
      ).docs.map((d) => d.data());
      const defaultComments = (
        await firebase
          .firestore()
          .collectionGroup("examCommentTranslations")
          .get()
      ).docs.map((d) => d.data());      
      setState((s) => {
        return {
          ...s,
          examReasons: examComments,
          trickNames: trickNames,
          defaultComments: defaultComments,
          tricks: tricks
        };
      });
    };
    getTrickNamesAndExamReasons();
  }, []);

  return (
    <TrainerContext.Provider value={{ ...state, setPendingExam, setState }}>
      { props.children }
    </TrainerContext.Provider>
  );
}
